// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"a92c218e","975":"fccc1a64"}[chunkId] + ".chunk.js";
};